import React from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import withConfig from 'config/withConfig';
import {resetSelectedSpot} from 'spot/spot-actions';
import {userLogout} from 'user/user-actions';
import Navigation from './Navigation';

const HeaderMobile = ({isProduction, expandedData, collapsedData}) => {
    const dispatch = useDispatch();
    const {data: user} = useSelector(state => state.user);
    const clearSelectedSpot = () => {
        dispatch(resetSelectedSpot());
    };
    const onUserLogout = () => {
        dispatch(userLogout());
    };

    return (
        <header className="Header" role="banner">
            <Navigation
                isProduction={isProduction}
                user={user}
                collapsedData={collapsedData}
                expandedData={expandedData}
                onItemSelected={clearSelectedSpot}
                onUserLogout={onUserLogout}
            />
        </header>
    );
};

HeaderMobile.propTypes = {
    isProduction: PropTypes.bool,
    expandedData: PropTypes.array.isRequired,
    collapsedData: PropTypes.array.isRequired,
};

export default withConfig(['isProduction'])(HeaderMobile);
